import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=0d0a6d2a&"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports